import { useState, useRef, useCallback, useEffect, useMemo } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  AppBar,
  Box,
  Button,
  Container,
  Card,
  CardContent,
  Chip,
  Dialog,
  DialogContent,
  Grid,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Icon,
  IconButton,
  Typography,
  Backdrop,
  CircularProgress,
  useTheme,
} from "@mui/material";
import AgGridTable from "../../utilities/AgGridTable";
import FormPageHeader from "../../utilities/FormPageHeader";
import { useLocation, useNavigate } from "react-router-dom";
import customStyles from "app/shared-components/SelectCustomStyle";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import ProjectOrderSuccess from "./ProjectOrderSuccess";
import { useDispatch } from "react-redux";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Select from "react-select";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { toast } from "react-toastify";
import { AgGridReact } from "ag-grid-react";
import { styled } from "@mui/material/styles";
import WarningIcon from "@mui/icons-material/Warning";
const rangeUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findRanges}`;
const colorUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.ranges}`;
const handleUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllHandlesByVendor}`;
const carcassUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllCarcassByVendor}`;
const newPrjOrderUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.newCustomerProjectOrder}`;
const deleteFileUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.deleteFile}`;
const uploadOrderFileUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.uploadOrderFile}`;
const showFixedValue = (props) => {
  let formattedNumbers;
  if (Number.isNaN(props?.value) || props?.value === 0 || !props?.value) {
    formattedNumbers = "";
  } else {
    if (props.colDef.field === "volume" || props.colDef.field === "weight") {
      formattedNumbers = new Intl.NumberFormat("en-US", {
        maximumFractionDigits: 3,
        minimumFractionDigits: 3,
      }).format(props?.value);
    } else {
      formattedNumbers = new Intl.NumberFormat("en-US", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(props?.value);
    }
  }
  return <p className="text-right">{`${formattedNumbers}`}</p>;
};
const ColorButton = styled(Button)(({ theme }) => ({
  color: `${theme.palette.secondary.contrastText} !important`,
  backgroundColor: theme.palette.secondary.main,
  padding: "5px 15px",
  borderRadius: "20px",
  cursor: "pointer",
  display: "block",
  textAlign: "center",
  position: "relative",
  fontSize: "12px",
  "&:hover": {
    backgroundColor: theme.palette.secondary.dark,
  },

  "&[disabled]": {
    opacity: 0.4,
    background: theme.palette.action.disabledBackground,
    color: theme.palette.text.disabled,
    "& .file": {
      cursor: "not-allowed",
    },
  },

  "& .file": {
    opacity: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    cursor: "pointer",
  },
}));

const totalListPrice = (props) => {
  const LPWG1 = props?.data?.wg1;
  const LPWG2 = props?.data?.wg2;
  if (LPWG1 && LPWG2) {
    const total = Number(LPWG1) + Number(LPWG2);
    return new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(total);
  }
};

export default function SpecialPRJOrderSummary(props) {
  const location = useLocation();
  const dataInUrl = location?.state?.payload;
  const theme = useTheme();
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(0);
  const gridRef = useRef(null);
  const [openSuccessOrder, setOpenSuccessOrder] = useState(false);
  const [currentOrder, setCurrentOrder] = useState([]);
  const [error, setError] = useState();
  const [product, setProduct] = useState();
  const [formValues, setFormValues] = useState([
    {
      range: {},
      priceGroup: {},
      color: {},
      carcass: {},
      handle: {},
    },
  ]);
  const [range, setRange] = useState([]);
  const [color, setColor] = useState([]);
  const [priceGroup, setPriceGroup] = useState([]);
  const [handles, setHandles] = useState([]);
  const [carcass, setCarcass] = useState([]);
  const [selectedRange, setSelectedRange] = useState({});
  const [data, setData] = useState(null);
  const [customerId, setCustomerId] = useState();
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const hiddenDRWFile = useRef(null);
  const hiddenDicountFile = useRef(null);
  const hiddenADFile = useRef(null);
  const hiddenOrderCheckFile = useRef(null);
  const hiddenDrawingFile = useRef(null);
  const [DRWFile, setDRWFile] = useState(null);
  const [drwFileId, setDrwFileId] = useState("");
  const [appliancesDetailFileId, setAppliancesDetailFileId] = useState("");
  const [orderCheckFileId, setOrderCheckFileId] = useState("");
  const [drawingFileId, setDrawingFileId] = useState("");
  const [appliancesDetail, setAppliancesDetail] = useState(null);
  const [orderCheckFile, setOrderCheckFile] = useState(null);
  const [drawingFile, setDrawingFile] = useState(null);
  const [sharedLater, setSharedLater] = useState(false);
  const [notApplicable, setNotApplicable] = useState(false);
  const [drwFileSupersedes, setDrwFileSupersedes] = useState(false);
  const [uploadValue, setUploadValue] = useState([{ uploadFile: null }]);
  const [expanded, setExpanded] = useState("panel1");
  const [loading, setLoading] = useState(false);

  const overviewColumnDefs = [
    // {
    //   maxWidth: 50,
    //   sortable: false,
    //   filter: false,
    //    checkboxSelection: true,
    //     headerCheckboxSelection: true,
    //     headerCheckboxSelectionFilteredOnly: true,

    // },

    {
      field: "typeName",
      headerName: "TYPE Name",
      rowGroup: true,
      hide: true,
      valueFormatter: (params) =>
        params.value ? params.value.toUpperCase() : "",
    },

    {
      field: "uniqId",
      headerName: "Uniq ID",
      minWidth: 70,
      flex: 1,
      valueFormatter: (params) =>
        params.value ? params.value.toUpperCase() : "",
    },

    {
      field: "commissionName",
      headerName: "Commission Name",
      minWidth: 180,
      flex: 1,
    },

    { field: "volume", minWidth: 50, flex: 1, cellRenderer: showFixedValue },
    { field: "weight", minWidth: 50, flex: 1, cellRenderer: showFixedValue },

    {
      field: "wg1",
      headerName: "List Price WG1",
      minWidth: 50,
      flex: 1,
      cellRenderer: showFixedValue,
    },

    {
      field: "wg2",
      headerName: "List Price WG2",
      minWidth: 50,
      flex: 1,
      cellRenderer: showFixedValue,
    },

    {
      field: "totalWGPrice",
      headerName: "Total List Price",
      minWidth: 50,
      flex: 1,
      cellRenderer: totalListPrice,
    },

    { field: "range1", headerName: "Range 1", minWidth: 60, flex: 1 },
    {
      field: "priceGroup1",
      headerName: "Price Group 1",
      minWidth: 60,
      flex: 1,
    },
    { field: "color1", headerName: "Front Color 1", minWidth: 60, flex: 1 },
    { field: "carcass1", headerName: "Carcass 1", minWidth: 60, flex: 1 },
    { field: "handle1", headerName: "Handle 1", minWidth: 60, flex: 1 },
    { field: "range2", headerName: "Range 2", minWidth: 60, flex: 1 },
    {
      field: "priceGroup2",
      headerName: "Price Group 2",
      minWidth: 60,
      flex: 1,
    },
    { field: "color2", headerName: "Front Color 2", minWidth: 60, flex: 1 },
    { field: "carcass2", headerName: "Carcass 2", minWidth: 60, flex: 1 },
    { field: "handle2", headerName: "Handle 2", minWidth: 60, flex: 1 },
    { field: "range3", minWidth: 60, headerName: "Range 3", flex: 1 },
    {
      field: "priceGroup3",
      headerName: "Price Group 3",
      minWidth: 60,
      flex: 1,
    },
    { field: "color3", headerName: "Front Color 3", minWidth: 60, flex: 1 },
    { field: "carcass3", headerName: "Carcass 3", minWidth: 60, flex: 1 },
    { field: "handle3", headerName: "Handle 3", minWidth: 60, flex: 1 },

    { field: "loadingWeek", minWidth: 60, flex: 1 },
    { field: "freight", minWidth: 80, flex: 1 },

    { field: "drwFileName", headerName: "DRW File", minWidth: 150, flex: 1 },
    {
      field: "applianceDetailName",
      headerName: "Appliance Detail",
      minWidth: 60,
      flex: 1,
    },
    {
      field: "orderCheckListName",
      headerName: "Order Checklist",
      minWidth: 60,
      flex: 1,
    },
    {
      field: "drawingFileNames",
      headerName: "Drawing File",
      minWidth: 60,
      flex: 1,
    },
  ];

  const autoGroupColumnDef = {
    headerName: "TYPE Name",
    minWidth: 200,
    flex: 1,
    headerCheckboxSelection: true,
    enableRowGroup: true,
    headerCheckboxSelectionFilteredOnly: false,
    cellRendererParams: {
      checkbox: true,
      suppressCount: false,
    },
  };

  const defaultColDef = {
    filter: true,
    floatingFilter: true,
    resizable: true,
    sortable: true,
    filter: "agMultiColumnFilter",
    domLayout: "autoHeight",
    tooltipShowDelay: 0,
    enableRowGroup: true,
    //  cellStyle: { borderRight: '1px solid #757575' },

    filterParams: {
      filters: [
        {
          filter: "agTextColumnFilter",
          filterParams: { buttons: ["clear"] },
        },
        {
          filter: "agSetColumnFilter",
          filterParams: { defaultToNothingSelected: true, buttons: ["clear"] },
        },
      ],
    },
  };
  const isMaterialFormValid = (values) => {
    return (
      values?.range?.value &&
      values?.color?.value &&
      values?.carcass?.value &&
      values?.handle?.value
    );
  };

  const getSelectedTypes = () => {
    const api = gridRef.current?.api;
    if (!api) return [];

    const selectedRows = api.getSelectedRows() || [];
    return [...new Set(selectedRows.map((row) => row.projectTypeNum))];
  };

  const selectedTypes = getSelectedTypes();
  const totalTypes = data?.projectTypeInfo?.length || 0;

  const isSingle = selectedTypes.length === 1;
  const isAllSelected = selectedTypes.length === totalTypes;
  const isApplyEnabled = useMemo(() => {
    if (!formValues?.length) return false;

    const firstRowValid = isMaterialFormValid(formValues[0]);
    if (!firstRowValid) return false;

    const additionalRowsValid = formValues.slice(1).every((row) => {
      const isEmpty =
        !row?.range && !row?.color && !row?.carcass && !row?.handle;

      // ignore empty rows
      if (isEmpty) return true;

      // if user touched it → it must be valid
      return isMaterialFormValid(row);
    });

    const hasSelection = selectedRows?.length > 0;

    return additionalRowsValid && hasSelection;
  }, [formValues, selectedRows]);
  const getRowStyle = (params) => {
    if (params.data?.isMaterialInvalid) {
      return {
        border: `1px solid ${theme.palette.error.main}`,
      };
    }

    return null;
  };

  useEffect(() => {
    if (location.state && !data) {
      setData(location.state.payload);
      setProduct(location.state.product);

      navigate(".", { replace: true, state: null });
    }
  }, [location.state, data, navigate]);

  useEffect(() => {
    if (!dataInUrl && !data) {
      navigate("/order/special-project-order", { replace: true });
    }
  }, [dataInUrl, data, navigate]);
  useEffect(() => {
    if (data) {
      setSelectedRowData(data.projectTypeInfo ?? []);
      setCustomerId(data?.customerId);
    }
  }, [data]);

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "Project summary.xlsx",
      sheetName: "Project Summary",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);
  const isBooting = !data;
  const isMaterialCompleted = (type) => {
    return type.range1 && type.color1 && type.carcass1 && type.handle1;
  };
  const expandInvalidGroups = (api) => {
    api.forEachNode((node) => {
      if (node.group) {
        const hasInvalidChild = node.allLeafChildren?.some(
          (child) => child.data?.isMaterialInvalid,
        );

        if (hasInvalidChild) {
          node.setExpanded(true); // ✅ expand group
        } else {
          node.setExpanded(false); // optional collapse valid ones
        }
      }
    });
  };
  const materialProgress = useMemo(() => {
    if (!data?.projectTypeInfo?.length) {
      return {
        completed: 0,
        total: 0,
        allDone: false,
        remainingTypes: [],
      };
    }

    const total = data.projectTypeInfo.length;

    const completedTypes = data.projectTypeInfo.filter((type) =>
      isMaterialCompleted(type),
    );

    const remainingTypes = data.projectTypeInfo
      .filter((type) => !isMaterialCompleted(type))
      .map((type) => type.typeName);

    return {
      completed: completedTypes.length,
      total,
      allDone: completedTypes.length === total && total > 0,
      remainingTypes,
    };
  }, [data]);
  const expandAndScrollToInvalid = (api) => {
    let firstInvalidGroupNode = null;

    api.forEachNode((node) => {
      if (node.group) {
        const hasInvalidChild = node.allLeafChildren?.some(
          (child) => child.data?.isMaterialInvalid,
        );

        if (hasInvalidChild) {
          node.setExpanded(true);

          if (!firstInvalidGroupNode) {
            firstInvalidGroupNode = node;
          }
        }
      }
    });

    if (firstInvalidGroupNode) {
      setTimeout(() => {
        api.ensureNodeVisible(firstInvalidGroupNode, "top");
      }, 50);
    }
  };
  const resetFormValues = () => {
    const set = [];
    formValues.map(() => {
      set.push({ range: {}, color: {}, carcass: {}, handle: {} });
    });
    setFormValues(() => [...set]);
  };
  const onGridReady = (params) => {
    setTimeout(() => {
      const allColumnIds = [];
      params.columnApi.getColumns().forEach((column) => {
        allColumnIds.push(column.getId());
      });

      params.columnApi.autoSizeColumns(allColumnIds);

      // 🔥 expand + scroll
      expandAndScrollToInvalid(params.api);
    }, 100);
  };
  useEffect(() => {
    if (product?.id) {
      getRangeList();
      getHandleList();
      getCarcassList();
    }
  }, [product]);

  // const handleRangeChange = (data,index, field) => {
  //   setFormValues((prev) => {
  //     const updated = [...prev];
  //     const row = { ...updated[0] };

  //     row[field] = { value: data.value, label: data.label };

  //     if (field === "range") {
  //       row.color = null;
  //       row.priceGroup = {
  //         value: data.priceGroup,
  //         label: data.priceGroup,
  //       };

  //       setSelectedRange({
  //         value: data.value,
  //         label: data.label,
  //         id: data.id,
  //       });

  //       OAuthService.getList(`${colorUrl}/${data.id}/variations`)
  //         .then((list) => {
  //           const rangeVariations = list.data?._embedded?.rangeVariations;

  //           const colors = rangeVariations?.map((variations) => ({
  //             value: variations.productId,
  //             label: `${variations.productId}-${variations.productName}`,
  //           }));

  //           setColor([colors]);
  //         })
  //         .catch((err) => toast.error(err.message));
  //     }

  //     updated[0] = row;
  //     return updated;
  //   });
  // };

  // ✅ FIX Bug 1: Never mutate state directly — always produce new objects
  const handleRangeChange = (data, index, field) => {
    setFormValues((prev) => {
      const updated = prev.map((row, i) => {
        if (i !== index) return row;

        const newRow = {
          ...row,
          [field]: { value: data.value, label: data.label },
        };

        if (field === "range") {
          newRow.color = {};
          newRow.priceGroup = {
            value: data.priceGroup,
            label: data.priceGroup,
          };
        }

        return newRow;
      });

      return updated;
    });

    if (field === "range") {
      setSelectedRange({ value: data.value, label: data.label, id: data.id });

      OAuthService.getList(`${colorUrl}/${data.id}/variations`)
        .then((list) => {
          const rangeVariations = list.data?._embedded?.rangeVariations;
          const colors = rangeVariations?.map((v) => ({
            value: v.productId,
            label: `${v.productId}-${v.productName}`,
          }));

          setColor((prev) => {
            const updated = [...prev];
            updated[index] = colors;
            return updated;
          });
        })
        .catch((err) => toast.error(err.message));
    }
  };
  const handleApplyMaterialInfo = () => {
    if (!gridRef.current) return;
    setLoading(true);
    const api = gridRef.current.api;

    const selectedNodes = api.getSelectedNodes();
    const selectedLeafRows = selectedNodes
      .filter((node) => !node.group)
      .map((node) => node.data);

    if (!selectedLeafRows.length) {
      toast.warning("Please select at least one row");
      return;
    }

    const selectedProjectTypes = new Set(
      selectedLeafRows.map((row) => row.projectTypeNum),
    );

    setData((prev) => {
      if (!prev) return prev;

      const MAX_ROWS = 3;

      const updatedProjectTypeInfo = prev.projectTypeInfo.map((type) => {
        if (!selectedProjectTypes.has(type.projectTypeNum)) {
          return type;
        }

        const updatedType = { ...type };

        for (let i = 1; i <= MAX_ROWS; i++) {
          const row = formValues[i - 1];

          updatedType[`range${i}`] = row?.range?.label || "";
          updatedType[`range${i}Id`] = row?.range?.value || "";
          updatedType[`priceGroup${i}`] = row?.priceGroup?.value || "";

          updatedType[`color${i}`] = row?.color?.label || "";
          updatedType[`color${i}Id`] = row?.color?.value || "";

          updatedType[`carcass${i}`] = row?.carcass?.label || "";
          updatedType[`carcass${i}Id`] = row?.carcass?.value || "";

          updatedType[`handle${i}`] = row?.handle?.label || "";
          updatedType[`handle${i}Id`] = row?.handle?.value || "";
        }

        updatedType.isMaterialInvalid = !(
          updatedType.range1Id &&
          updatedType.color1Id &&
          updatedType.carcass1Id &&
          updatedType.handle1Id
        );

        return updatedType;
      });

      return {
        ...prev,
        projectTypeInfo: [...updatedProjectTypeInfo],
      };
    });
    api.refreshCells({ force: true });
    setTimeout(() => {
      const api = gridRef.current.api;

      expandAndScrollToInvalid(api);
      api.redrawRows();
    }, 0);
    setLoading(false);
    toast.success("Material info applied successfully");
  };

  const onSelectionChanged = () => {
    const selectedLeafRows = gridRef.current.api
      .getSelectedNodes()
      .filter((node) => !node.group)
      .map((node) => node.data);

    setSelectedRows(selectedLeafRows);
  };
  const getRangeList = async () => {
    OAuthService.getList(`${rangeUrl}?vendorId=${product?.id}`)
      .then((list) => {
        const ranges = list.data;
        setRange(
          ranges?.map((range) => ({
            value: range?.productId,
            label: `${range?.priceGroup?.pgId || "NA"}-${range?.productName}`,
            id: range.id,
            priceGroup: range?.priceGroup?.pgId,
          })),
        );
      })
      .catch((err) => toast.error(err.message));
  };
  const getHandleList = async () => {
    OAuthService.getList(`${handleUrl}?vendorId=${product?.id}`)
      .then((list) => {
        const { handles } = list.data?._embedded;
        setHandles(
          handles?.map((handle) => ({
            value: handle.productId,
            label: `${handle.productId}-${handle.productName}`,
          })),
        );
      })
      .catch((err) => toast.error(err.message));
  };

  const getCarcassList = async () => {
    OAuthService.getList(`${carcassUrl}?vendorId=${product?.id}`)
      .then((list) => {
        const { carcasses } = list.data?._embedded;
        setCarcass(
          carcasses?.map((carcasse) => ({
            value: carcasse.productId,
            label: `${carcasse.productId}-${carcasse.productName}`,
          })),
        );
      })
      .catch((err) => toast.error(err.message));
  };
  const [key, setKey] = useState(0);

  const removeDRWFile = async () => {
    try {
      await OAuthService.deleteData(deleteFileUrl, drwFileId);

      const api = gridRef.current?.api;
      const rows = api?.getSelectedRows() || [];
      const selectedProjectTypes = rows.map((r) => r.projectTypeNum);

      setData((prev) => {
        if (!prev) return prev;

        const updated = prev.projectTypeInfo.map((type) => {
          if (selectedProjectTypes.includes(type.projectTypeNum)) {
            return {
              ...type,
              drwFile: "",
              drwFileName: "",
            };
          }
          return type;
        });

        return { ...prev, projectTypeInfo: updated };
      });

      api?.refreshCells({ force: true });

      toast.success("File removed!");
      hiddenDRWFile.current.value = null;
      setDRWFile(null);
      setDrwFileId("");
    } catch (error) {
      toast.error(error.message);
    }
  };
  const removeADFile = async () => {
    try {
      await OAuthService.deleteData(deleteFileUrl, appliancesDetailFileId);

      const api = gridRef.current?.api;
      const rows = api?.getSelectedRows() || [];
      const selectedProjectTypes = rows.map((r) => r.projectTypeNum);

      setData((prev) => {
        if (!prev) return prev;

        const updated = prev.projectTypeInfo.map((type) => {
          if (selectedProjectTypes.includes(type.projectTypeNum)) {
            return {
              ...type,
              applianceDetail: "",
              applianceDetailName: "",
            };
          }
          return type;
        });

        return { ...prev, projectTypeInfo: updated };
      });

      api?.refreshCells({ force: true });

      toast.success("File removed!");
      hiddenADFile.current.value = null;
      setAppliancesDetail(null);
      setAppliancesDetailFileId("");
    } catch (error) {
      toast.error(error.message);
    }
  };
  const removeOrderCheckFile = async () => {
    try {
      await OAuthService.deleteData(deleteFileUrl, orderCheckFileId);

      const api = gridRef.current?.api;
      const rows = api?.getSelectedRows() || [];
      const selectedProjectTypes = rows.map((r) => r.projectTypeNum);

      setData((prev) => {
        if (!prev) return prev;

        const updated = prev.projectTypeInfo.map((type) => {
          if (selectedProjectTypes.includes(type.projectTypeNum)) {
            return {
              ...type,
              orderCheckList: "",
              orderCheckListName: "",
            };
          }
          return type;
        });

        return { ...prev, projectTypeInfo: updated };
      });

      api?.refreshCells({ force: true });

      toast.success("File removed!");
      hiddenOrderCheckFile.current.value = null;
      setOrderCheckFile(null);
      setOrderCheckFileId("");
    } catch (error) {
      toast.error(error.message);
    }
  };

  const removeDrawingFile = async (index) => {
    try {
      await OAuthService.deleteData(deleteFileUrl, drawingFileId[index]);

      const filteredFiles = [...uploadValue];
      filteredFiles[index] = { id: "", uploadFile: null };

      setUploadValue(filteredFiles);

      const tempIds = filteredFiles.map((i) => i.id).filter(Boolean);

      const api = gridRef.current?.api;
      const rows = api?.getSelectedRows() || [];
      const selectedProjectTypes = rows.map((r) => r.projectTypeNum);

      setData((prev) => {
        if (!prev) return prev;

        const updated = prev.projectTypeInfo.map((type) => {
          if (selectedProjectTypes.includes(type.projectTypeNum)) {
            return {
              ...type,
              drawingFile: tempIds,
              drawingFileNames: filteredFiles
                .map((i) => i.uploadFile?.name)
                .filter(Boolean),
            };
          }
          return type;
        });

        return { ...prev, projectTypeInfo: updated };
      });

      api?.refreshCells({ force: true });

      toast.success("File removed!");

      hiddenDrawingFile.current.value = null;
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleDRWUpload = async (e) => {
    const fileUploaded = e.target.files[0];
    if (!fileUploaded) return;

    const selectedTypes = getSelectedTypes();
    const totalTypes = data?.projectTypeInfo?.length || 0;

    const isAllSelected = selectedTypes.length === totalTypes;
    const fileExtension = fileUploaded.name.split(".").pop().toLowerCase();

    if (selectedTypes.length === 0) {
      toast.warning("Please select at least one type");
      return;
    }

    if (isAllSelected && fileExtension !== "prw") {
      toast.warning("Please upload a .prw file when all types are selected");
      return;
    }

    if (!isAllSelected && fileExtension !== "drw") {
      toast.warning(
        "DRW is allowed only for selected types. To upload PRW, select all types.",
      );
      return;
    }

    if (!isAllSelected && selectedTypes.length > 1 && fileExtension === "drw") {
      toast.warning(
        "DRW is applicable for one type only. Please select a single type and re-upload.",
      );
      return;
    }
    setLoading(true);
    try {
      const payload = {
        file: [fileUploaded],
        customerId,
        commissionName: selectedRows[0]?.commissionName,
        isOriginal: true,
      };

      const list = await OAuthService.addFiles(uploadOrderFileUrl, payload);
      const fileId = list.data.map((file) => file.id).join("");
      const fileName = fileUploaded.name;

      setData((prev) => {
        if (!prev) return prev;

        const updatedProjectTypeInfo = prev.projectTypeInfo.map((type) => {
          if (selectedTypes.includes(type.projectTypeNum)) {
            return { ...type, drwFile: fileId, drwFileName: fileName };
          }
          return type;
        });

        return { ...prev, projectTypeInfo: updatedProjectTypeInfo };
      });

      gridRef.current?.api.refreshCells({ force: true });
      setLoading(false);
      toast.success("File uploaded successfully");

      setKey((prevKey) => prevKey + 1);
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
      hiddenDRWFile.current.value = null;
      setLoading(false);
      setDRWFile(null);
    }
  };
  const handleADUpload = async (e) => {
    const fileUploaded = e.target.files[0];
    if (!fileUploaded) return;
    setLoading(true);
    try {
      const payload = {
        file: [fileUploaded],
        customerId,
        commissionName: selectedRows[0]?.commissionName,
        isOriginal: true,
      };

      const list = await OAuthService.addFiles(uploadOrderFileUrl, payload);

      const fileId = list.data.map((file) => file.id).join("");
      const fileName = fileUploaded.name;

      // setAppliancesDetailFileId(fileId);
      // setAppliancesDetail(fileUploaded);

      const api = gridRef.current?.api;
      const rows = api?.getSelectedRows() || [];
      const selectedProjectTypes = rows.map((r) => r.projectTypeNum);

      setData((prev) => {
        if (!prev) return prev;

        const updated = prev.projectTypeInfo.map((type) => {
          if (selectedProjectTypes.includes(type.projectTypeNum)) {
            return {
              ...type,
              applianceDetail: fileId,
              applianceDetailName: fileName,
            };
          }
          return type;
        });

        return { ...prev, projectTypeInfo: updated };
      });

      api?.refreshCells({ force: true });
      toast.success(" File uploaded successfully");
      setLoading(false);
      setKey((prev) => prev + 1);
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
      setLoading(false);
    }
  };
  const handleOrderCheckUpload = async (e) => {
    const fileUploaded = e.target.files[0];
    if (!fileUploaded) return;
    setLoading(true);
    try {
      const payload = {
        file: [fileUploaded],
        customerId,
        commissionName: selectedRows[0]?.commissionName,
        isOriginal: true,
      };

      const list = await OAuthService.addFiles(uploadOrderFileUrl, payload);

      const fileId = list.data.map((file) => file.id).join("");
      const fileName = fileUploaded.name;

      // setOrderCheckFileId(fileId);
      // setOrderCheckFile(fileUploaded);

      const api = gridRef.current?.api;
      const rows = api?.getSelectedRows() || [];
      const selectedProjectTypes = rows.map((r) => r.projectTypeNum);

      setData((prev) => {
        if (!prev) return prev;

        const updated = prev.projectTypeInfo.map((type) => {
          if (selectedProjectTypes.includes(type.projectTypeNum)) {
            return {
              ...type,
              orderCheckList: fileId,
              orderCheckListName: fileName,
            };
          }
          return type;
        });

        return { ...prev, projectTypeInfo: updated };
      });

      api?.refreshCells({ force: true });
      toast.success(" File uploaded successfully");
      setLoading(false);
      setKey((prev) => prev + 1);
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
      setLoading(false);
    }
  };
  const handleDrawingUpload = async (e, index) => {
    const file = e.target.files[0];
    if (!file) return;
    setLoading(true);
    try {
      const newUploadValue = [...uploadValue];
      const updatedItem = { ...newUploadValue[index], uploadFile: file };
      newUploadValue[index] = updatedItem;

      const payload = {
        file,
        customerId,
        commissionName: selectedRows[0]?.commissionName,
        isOriginal: true,
      };

      const list = await OAuthService.addFiles(uploadOrderFileUrl, payload);

      const fileId = list.data.map((file) => file.id)[0];
      const fileName = file.name;

      updatedItem.id = fileId;

      // setUploadValue(newUploadValue);
      // setDrawingFileId((prev) => [...prev, fileId]);

      const api = gridRef.current?.api;
      const rows = api?.getSelectedRows() || [];
      const selectedProjectTypes = rows.map((r) => r.projectTypeNum);

      const tempIds = newUploadValue.map((i) => i.id).filter(Boolean);

      setData((prev) => {
        if (!prev) return prev;

        const updated = prev.projectTypeInfo.map((type) => {
          if (selectedProjectTypes.includes(type.projectTypeNum)) {
            return {
              ...type,
              drawingFile: tempIds,
              drawingFileNames: newUploadValue
                .map((i) => i.uploadFile?.name)
                .filter(Boolean),
            };
          }
          return type;
        });

        return { ...prev, projectTypeInfo: updated };
      });

      api?.refreshCells({ force: true });
      toast.success(" File uploaded successfully");
      setLoading(false);
      setKey((prev) => prev + 1);
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
      setLoading(false);
    }
  };
  let addUploadFields = () => {
    const newField = { id: "", uploadFile: null };
    const newUploadValue = [...uploadValue, newField];
    setUploadValue(newUploadValue);
  };
  let removeUploadFields = (i) => {
    const newUploadValue = [...uploadValue];
    newUploadValue.splice(i, 1);
    setUploadValue(newUploadValue);
  };

  const mergeOrders = useMemo(() => {
    const extendedOrderList = selectedRowData.map((obj, typeIndex) => {
      const { orderList, ...mergeObject } = obj;

      const extendedOrderListItems = obj.orderList.map(
        (orderListItem, orderIndex) => ({
          ...orderListItem,
          ...mergeObject,

          // ⭐ ADD UNIQUE INTERNAL KEY
          __rowId: `${typeIndex}-${orderIndex}`,
        }),
      );

      return {
        ...obj,
        orderList: extendedOrderListItems,
      };
    });

    const orderList = extendedOrderList.map((list) => list.orderList);

    return [].concat(...orderList);
  }, [selectedRowData]);

  const orderAttachmentProgress = useMemo(() => {
    if (!data?.projectTypeInfo?.length)
      return { completed: 0, total: 0, allDone: false };

    const total = data.projectTypeInfo.length;

    const completed = data.projectTypeInfo.filter((order) => {
      const drwDone = order.drwFile;
      const applianceDone =
        order.applianceDetail || order.sharedLater || order.na;
      const orderCheckDone = order.orderCheckList || order.drawFileSupersedes;

      return drwDone && applianceDone && orderCheckDone;
    }).length;

    return { completed, total, allDone: completed === total };
  }, [data]);
  useEffect(() => {
    if (!selectedRows?.length) {
      setSharedLater(false);
      setNotApplicable(false);
      setDrwFileSupersedes(false);
      return;
    }

    const allSharedLater = selectedRows.every(
      (row) => row.sharedLater === true,
    );

    const allNotApplicable = selectedRows.every((row) => row.na === true);

    setSharedLater(allSharedLater);
    setNotApplicable(allNotApplicable);

    setDrwFileSupersedes(
      selectedRows.every((row) => row.drawFileSupersedes === true),
    );
  }, [selectedRows]);

  let removeFormFields = (i) => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };
  let addFormFields = () => {
    if (formValues.length < 3) {
      setFormValues([
        ...formValues,
        { range: {}, priceGroup: {}, color: {}, carcass: {}, handle: {} },
      ]);
    }
  };

  const handlePlaceOrder = async () => {
    try {
      setLoading(true);

      const cleanedData = {
        ...data,
        projectTypeInfo: data.projectTypeInfo.map((type) => {
          const {
            drwFileName,
            applianceDetailName,
            orderCheckListName,
            drawingFileNames,
            materialError1,
            materialError2,
            materialError3,
            isMaterialInvalid,

            ...rest
          } = type;
          return rest;
        }),
      };

      const list = await OAuthService.addData(newPrjOrderUrl, cleanedData);
      const responseData = list.data;
      console.log("PLACE ORDER:", responseData, list);
      setCurrentOrder(responseData);

      setOpenSuccessOrder(true);
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (materialProgress.allDone) {
      resetFormValues();
      setExpanded("panel2");
    }
  }, [materialProgress.allDone]);
  const orderHeaderAction = () => {
    // const navigate = useNavigate();
    return (
      <>
        <Button
          variant="contained"
          color="secondary"
          onClick={handlePlaceOrder}
          size="small"
          sx={{ minWidth: "auto" }}
          disabled={
            loading ||
            openSuccessOrder ||
            !materialProgress.allDone ||
            !orderAttachmentProgress.allDone
          }
        >
          {loading ? "Placing Order..." : "Place Order"}
        </Button>
      </>
    );
  };

  return (
    <>
      {isBooting ? (
        <div className="flex h-full items-center justify-center">
          <Typography variant="h6">Loading…</Typography>
        </div>
      ) : (
        <>
          <FormPageHeader
            componentName="Project Summary"
            pageName="Project Summary"
            onBtExport={onBtExport}
            currentPage="Project Summary"
            orderHeaderAction={orderHeaderAction()}
            error={error}
          />
          <Accordion
            expanded={expanded === "panel1"}
            onChange={() =>
              setExpanded(expanded === "panel1" ? false : "panel1")
            }
          >
            <AccordionSummary
              expandIcon={<ArrowDropDownIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography
                component="h2"
                sx={{
                  fontWeight: 600,
                  fontSize: "1.6rem",
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <span>Material Details</span>

                <span
                  style={{
                    color: materialProgress.allDone
                      ? theme.palette.success.main
                      : "inherit",
                    fontWeight: 500,
                  }}
                >
                  {materialProgress.allDone
                    ? "✅ Completed"
                    : `(${materialProgress.completed} / ${materialProgress.total} Completed)`}
                </span>
                {!materialProgress.allDone &&
                  materialProgress.remainingTypes.length > 0 && (
                    <span
                      style={{
                        color: theme.palette.error.main,
                        fontWeight: 500,
                      }}
                    >
                      <WarningIcon />
                      Material Info Yet to Be Added For:{" "}
                      {materialProgress.remainingTypes.join(", ")}
                    </span>
                  )}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box
                className="shadow mb-5 mt-5"
                sx={{
                  backgroundColor: theme.palette.background.paper,
                  p: 2,
                  position: "relative",
                  borderRadius: "1.6rem",
                  borderBottomRightRadius: 0,
                  mb: 2.5,
                  width: "100%",
                }}
              >
                {formValues.map((element, index) => {
                  const isLast = index === formValues.length - 1;

                  return (
                    <Grid
                      container
                      spacing={2}
                      alignItems="flex-end"
                      xs={12}
                      className={index ? "mt-4" : ""}
                      key={index}
                    >
                      <Grid item xs={12} sm={6} md={3}>
                        <label className="pb-8 flex">*Range</label>
                        <Select
                          value={formValues?.[index]?.range}
                          onChange={(e) => handleRangeChange(e, index, "range")}
                          name="range"
                          options={range}
                          styles={customStyles()}
                          className="w-full"
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={3}>
                        <label className="pb-8 flex">*Color</label>
                        <Select
                          value={formValues?.[index]?.color}
                          onChange={(e) => handleRangeChange(e, index, "color")}
                          name="color"
                          options={color[index]}
                          styles={customStyles()}
                          className="w-full"
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={3}>
                        <label className="pb-8 flex">*Carcass</label>
                        <Select
                          value={formValues?.[index]?.carcass}
                          onChange={(e) =>
                            handleRangeChange(e, index, "carcass")
                          }
                          name="carcass"
                          options={carcass}
                          styles={customStyles()}
                          className="w-full"
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={3}>
                        <label className="pb-8 flex">*Handle</label>
                        <Select
                          value={formValues?.[index]?.handle}
                          onChange={(e) =>
                            handleRangeChange(e, index, "handle")
                          }
                          name="handle"
                          options={handles}
                          styles={customStyles()}
                          className="w-full"
                        />
                      </Grid>

                      {/* Apply button only on last row */}
                      {isLast && (
                        <Grid item xs={2}>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleApplyMaterialInfo}
                            disabled={!isApplyEnabled}
                            size="small"
                            sx={{ minWidth: "auto" }}
                          >
                            Apply
                          </Button>
                        </Grid>
                      )}

                      {/* Close button aligned properly */}
                      {index !== 0 && (
                        <Grid item xs={1} display="flex" alignItems="center">
                          <IconButton
                            color="secondary"
                            sx={{
                              position: "absolute",
                              right: { xs: 0, md: "-30px" },
                              top: { xs: 0, md: "auto" },
                              bottom: { xs: "auto", md: 4 },
                            }}
                            onClick={() => removeFormFields(index)}
                          >
                            <FuseSvgIcon size={14}>
                              heroicons-outline:x
                            </FuseSvgIcon>
                          </IconButton>
                        </Grid>
                      )}
                    </Grid>
                  );
                })}

                {formValues.length < 3 && (
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => addFormFields()}
                    size="small"
                    sx={{
                      position: "absolute",
                      bottom: "-32px",
                      right: "256px",
                      borderTopRightRadius: 0,
                      borderTopLeftRadius: 0,
                    }}
                  >
                    <FuseSvgIcon>heroicons-outline:plus</FuseSvgIcon>
                  </Button>
                )}
              </Box>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel2"}
            onChange={() =>
              setExpanded(expanded === "panel2" ? false : "panel2")
            }
          >
            <AccordionSummary
              expandIcon={<ArrowDropDownIcon />}
              aria-controls="panel2-content"
              id="panel2-header"
            >
              <Typography
                component="h2"
                sx={{
                  fontWeight: 600,
                  fontSize: "1.6rem",
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <span>Order Attachments</span>
                <span
                  style={{
                    color: orderAttachmentProgress.allDone
                      ? theme.palette.success.main
                      : "inherit",
                    fontWeight: 500,
                  }}
                >
                  {orderAttachmentProgress.allDone
                    ? "✅ Completed"
                    : `(${orderAttachmentProgress.completed} / ${orderAttachmentProgress.total} Completed)`}
                </span>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Container component="main" maxWidth="md" sx={{ py: 1 }}>
                <Grid container xs={12} className="mb-4">
                  <Grid
                    container
                    xs={12}
                    spacing={1}
                    sx={{ position: "relative" }}
                  >
                    <Grid item xs={12} sm={6} md={3}>
                      <Card>
                        <CardContent>
                          <label className="pb-8 flex">
                            *{isAllSelected ? "PRW File" : "DRW File"}
                          </label>

                          <ColorButton
                            variant="contained"
                            component="label"
                            disabled={selectedTypes.length === 0 || DRWFile}
                          >
                            <FuseSvgIcon
                              size={18}
                              sx={{ display: "inline-block" }}
                            >
                              heroicons-outline:upload
                            </FuseSvgIcon>{" "}
                            Upload
                            <input
                              type="file"
                              className="file"
                              onChange={handleDRWUpload}
                              key={key}
                              ref={hiddenDRWFile}
                              disabled={
                                loading || selectedTypes.length === 0 || DRWFile
                              }
                              accept={isAllSelected ? ".prw" : ".drw"}
                            />
                          </ColorButton>

                          {DRWFile && (
                            <Box className="mt-16">
                              <Chip
                                label={DRWFile?.name}
                                onDelete={removeDRWFile}
                              />
                            </Box>
                          )}
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Card>
                        <CardContent>
                          <label className="pb-8 flex">
                            *Appliances Detail
                          </label>

                          <ColorButton
                            variant="contained"
                            component="label"
                            disabled={
                              appliancesDetail ||
                              sharedLater ||
                              notApplicable ||
                              selectedRows.length === 0
                            }
                          >
                            <FuseSvgIcon
                              size={18}
                              sx={{ display: "inline-block" }}
                            >
                              heroicons-outline:upload
                            </FuseSvgIcon>{" "}
                            Upload
                            <input
                              type="file"
                              className="file"
                              key={key}
                              onChange={handleADUpload}
                              ref={hiddenADFile}
                              disabled={
                                loading ||
                                appliancesDetail ||
                                sharedLater ||
                                notApplicable ||
                                selectedRows.length === 0
                              }
                            />
                          </ColorButton>
                          {appliancesDetail && (
                            <Box className="mt-16">
                              <Chip
                                label={appliancesDetail.name}
                                onDelete={removeADFile}
                              />
                            </Box>
                          )}
                        </CardContent>
                      </Card>

                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={sharedLater}
                              onChange={(event) => {
                                const checked = event.target.checked;
                                setSharedLater(checked);
                                setNotApplicable(false);

                                // Update grid data
                                const api = gridRef.current?.api;
                                const rows = api?.getSelectedRows() || [];
                                const selectedProjectTypes = rows.map(
                                  (r) => r.projectTypeNum,
                                );

                                setData((prev) => {
                                  if (!prev) return prev;

                                  const updated = prev.projectTypeInfo.map(
                                    (type) => {
                                      if (
                                        selectedProjectTypes.includes(
                                          type.projectTypeNum,
                                        )
                                      ) {
                                        return {
                                          ...type,
                                          sharedLater: checked,
                                          na: false,
                                          loadingWeek: checked
                                            ? "ONHOLD"
                                            : type.loadingWeek,
                                        };
                                      }
                                      return type;
                                    },
                                  );

                                  return { ...prev, projectTypeInfo: updated };
                                });

                                api?.refreshCells({ force: true });
                              }}
                            />
                          }
                          label="Will be shared later"
                          sx={{ "& span": { fontSize: "11px" } }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={notApplicable}
                              onChange={(event) => {
                                const checked = event.target.checked;
                                setNotApplicable(checked);
                                setSharedLater(false);

                                // Update grid data
                                const api = gridRef.current?.api;
                                const rows = api?.getSelectedRows() || [];
                                const selectedProjectTypes = rows.map(
                                  (r) => r.projectTypeNum,
                                );

                                setData((prev) => {
                                  if (!prev) return prev;

                                  const updated = prev.projectTypeInfo.map(
                                    (type) => {
                                      if (
                                        selectedProjectTypes.includes(
                                          type.projectTypeNum,
                                        )
                                      ) {
                                        return {
                                          ...type,
                                          na: checked,
                                          sharedLater: false,
                                        };
                                      }
                                      return type;
                                    },
                                  );

                                  return { ...prev, projectTypeInfo: updated };
                                });

                                api?.refreshCells({ force: true });
                              }}
                            />
                          }
                          label="NA"
                          sx={{ "& span": { fontSize: "11px" } }}
                        />
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Card>
                        <CardContent>
                          <label className="pb-8 flex">*Order Checklist</label>

                          <ColorButton
                            variant="contained"
                            component="label"
                            disabled={
                              orderCheckFile ||
                              drwFileSupersedes ||
                              selectedRows.length === 0
                            }
                          >
                            <FuseSvgIcon
                              size={18}
                              sx={{ display: "inline-block" }}
                            >
                              heroicons-outline:upload
                            </FuseSvgIcon>{" "}
                            Upload
                            <input
                              type="file"
                              className="file"
                              key={key}
                              onChange={handleOrderCheckUpload}
                              ref={hiddenOrderCheckFile}
                              disabled={
                                loading || orderCheckFile || drwFileSupersedes
                              }
                            />
                          </ColorButton>
                          {orderCheckFile && (
                            <Box className="mt-16">
                              <Chip
                                label={orderCheckFile.name}
                                onDelete={removeOrderCheckFile}
                              />
                            </Box>
                          )}
                        </CardContent>
                      </Card>

                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={drwFileSupersedes}
                              onChange={(event) => {
                                const checked = event.target.checked;
                                setDrwFileSupersedes(checked);

                                // Update grid data
                                const api = gridRef.current?.api;
                                const rows = api?.getSelectedRows() || [];
                                const selectedProjectTypes = rows.map(
                                  (r) => r.projectTypeNum,
                                );

                                setData((prev) => {
                                  if (!prev) return prev;

                                  const updated = prev.projectTypeInfo.map(
                                    (type) => {
                                      if (
                                        selectedProjectTypes.includes(
                                          type.projectTypeNum,
                                        )
                                      ) {
                                        return {
                                          ...type,
                                          drawFileSupersedes: checked,
                                        };
                                      }
                                      return type;
                                    },
                                  );

                                  return { ...prev, projectTypeInfo: updated };
                                });

                                api?.refreshCells({ force: true });
                              }}
                            />
                          }
                          label="DRW file supersedes"
                          sx={{ "& span": { fontSize: "11px" } }}
                        />
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      {(uploadValue?.length
                        ? uploadValue
                        : [{ id: "", uploadFile: null }]
                      ).map((element, index) => (
                        <Card sx={{ position: "relative", mb: 1 }}>
                          <CardContent>
                            <label className="pb-8 flex">Drawing File</label>

                            <ColorButton
                              variant="contained"
                              component="label"
                              disabled={
                                uploadValue[index]?.id?.trim().length > 0
                                  ? true
                                  : false ||
                                    selectedRows.length === 0 ||
                                    loading
                              }
                            >
                              <FuseSvgIcon
                                size={18}
                                sx={{ display: "inline-block" }}
                              >
                                heroicons-outline:upload
                              </FuseSvgIcon>{" "}
                              Upload
                              <input
                                type="file"
                                className="file"
                                key={key}
                                onChange={(event) =>
                                  handleDrawingUpload(event, index)
                                }
                                ref={hiddenDrawingFile}
                                disabled={
                                  uploadValue[index]?.id?.trim().length > 0
                                    ? true
                                    : false ||
                                      selectedRows.length === 0 ||
                                      loading
                                }
                              />
                            </ColorButton>
                            {uploadValue[index]?.uploadFile?.name?.length >
                              0 && (
                              <Box className="mt-16">
                                <Chip
                                  label={
                                    uploadValue[index]?.uploadFile?.name ||
                                    drawingFile.attachmentName
                                  }
                                  onDelete={() => removeDrawingFile(index)}
                                />
                              </Box>
                            )}
                          </CardContent>
                          {index ? (
                            <IconButton
                              onClick={() => removeUploadFields(index)}
                              size="small"
                              sx={{
                                position: "absolute",
                                top: 0,
                                right: 0,
                              }}
                            >
                              <FuseSvgIcon size={18}>
                                heroicons-outline:x
                              </FuseSvgIcon>
                            </IconButton>
                          ) : null}
                        </Card>
                      ))}
                    </Grid>
                    <IconButton
                      variant="contained"
                      color="primary"
                      onClick={() => addUploadFields()}
                      size="small"
                      sx={{
                        marginRight: { xs: 0, md: "-34px" },
                        height: "34px",
                        top: { xs: 0, md: "45px" },
                        ml: { xs: "auto", md: 0 },
                        mt: { xs: 1, md: 0 },
                      }}
                    >
                      <FuseSvgIcon>heroicons-outline:plus</FuseSvgIcon>
                    </IconButton>
                  </Grid>
                </Grid>
              </Container>
            </AccordionDetails>
          </Accordion>
          <div
            className={`h-full ${
              theme.palette.mode === "dark"
                ? "ag-theme-alpine-dark"
                : "ag-theme-alpine"
            } grid`}
            style={{ height: "100%", width: "100%" }}
          >
            <AgGridReact
              ref={gridRef}
              rowData={mergeOrders}
              onGridReady={onGridReady}
              columnDefs={overviewColumnDefs}
              autoGroupColumnDef={autoGroupColumnDef}
              rowSelection="multiple"
              groupSelectsChildren={true}
              // groupDisplayType="groupRows"
              defaultColDef={defaultColDef}
              rowGroupPanelShow={"always"}
              onSelectionChanged={onSelectionChanged}
              getRowId={(params) => params.data.__rowId}
              animateRows={true}
              style={{ height: "100%", width: "100%" }}
              wrapHeaderText={true}
              headerHeight={28}
              rowHeight={22}
              getRowStyle={getRowStyle}
              suppressDragLeaveHidesColumns={true}
              cellSelection={true}
              suppressRowClickSelection={true}
            />
          </div>

          <ProjectOrderSuccess
            open={openSuccessOrder}
            currentOrder={currentOrder}
            setOpenSuccessOrder={setOpenSuccessOrder}
          />
          {loading && (
            <Backdrop open>
              <CircularProgress color="inherit" />
            </Backdrop>
          )}
        </>
      )}
    </>
  );
}
